import React from 'react';
import BlogPost from './blogpostcontainer';
import '../styles/blogpost.css';

const BlogSection = () => {
  return (
    <div className="basic-container">
      <p className="heading">Latest Blog Posts</p>

      <div className="blogs-container">
          <BlogPost title="Introduction to Neural Network" url="https://pelicanflowspace.vercel.app/" CNTitle="to be updated" />
          </div>
      <div className="blogs-container">
          <BlogPost title="Optimizing Hyperparameters 101" url="https://pelicanflowspace.vercel.app/" CNTitle="coming soon"/>
            </div>   
      <div className="blogs-container">
       <BlogPost title="Documentation of PelicanFlow" url="https://pelicanflow.vercel.app/projects/Documentation"CNTitle="PelicanflowGH工作流" />
        </div>
       <div className="blogs-container">
       <BlogPost title="More...." url="https://pelicanflowspace.vercel.app/"CNTitle="click for more info" />
        </div>
        </div>
  );
};

export default BlogSection;